module.exports = __webpack_public_path__ + "static/guillaume-rivals-df83a75c20b4757e096f2c8fc7ec0d4f.jpg";